import React, { useState, useEffect, useCallback } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { useForm, Controller } from "react-hook-form";
import { getSensors } from '../../../services/sensors/sensorsService';
import { getCrop, addCrop, editCrop } from '../../../services/crops/cropsService';
import { toCapitalizeCase } from '../../utils/ToCapitalizeCase';
import './../../../styles/error.css';

const CropView = () => {
    const navigate = useNavigate();
    const { cropId } = useParams();

    const { register, handleSubmit, reset,  control, setValue, getValues,formState: {errors} } = useForm({
        defaultValues:{
            sensors: [],
        }
    });
    
    const [accordionState, setAccordionState] = useState({
        accordion_1: false,
        accordion_2: false
    });
    
    const [sensors, setSensors] = useState([]);

    // Opciones constantes
    const BINARY_OPTIONS = [
        { label: 'Sí', value: 'true' },
        { label: 'No', value: 'false' },
    ];

    const CROP_OPTIONS = [
        { label: 'Flores', value: 'Flores'},
        { label: 'Palma', value: 'Palma'},
        { label: 'Café', value: 'Café'},
        { label: 'Aguacate', value: 'Aguacate'},
        { label: 'Tomate', value: 'Tomate'},
        { label: 'Gulupa', value: 'Gulupa'},
        { label: 'Arándanos', value: 'Arándanos'},
        { label: 'Aromáticas', value: 'Aromáticas'},
        { label: 'Otro', value: 'Otro'},
    ];

    const FERTILIZATION_OPTIONS = [
        { label: 'Orgánico líquido', value: 'Orgánico líquido' },
        { label: 'Orgánico granular', value: 'Orgánico granular' },
        { label: 'Químico líquido', value: 'Químico líquido' },
        { label: 'Químico granular', value: 'Químico granular' },
    ];

    const IRRIGATION_TYPE = [
        { label: 'Motobomba', value: 'Motobomba' },
        { label: 'Gravedad', value: 'Gravedad' },
    ];

    const PHONE_PATTERN = /^\d+$/;

    // const handleSensorSelection = (sensorId) => {
    //     const currentSensors = getValues("sensors") || [];
    //     const updatedSensors = currentSensors.includes(sensorId)
    //       ? currentSensors.filter((id) => id !== sensorId) // Quitar el sensor si ya está seleccionado
    //       : [...currentSensors, sensorId]; // Agregar el sensor si no está seleccionado
    
    //     setValue("sensors", updatedSensors); // Actualizar los sensores seleccionados
    // };


    const handleSensorSelection = (sensorId) => {
        // const updatedSensors = [sensorId];
        const currentSensors = getValues("sensors") || [];
        if(!currentSensors.includes(sensorId))
            setValue("sensors", [sensorId]); // Para un solo sensor
    };

    const toggleAccordion = useCallback((accordionName) => {
        setAccordionState(prev => ({
            ...prev,
            [accordionName]: !prev[accordionName]
        }));
    }, []);

    const handleCancel = useCallback(() => {
        navigate('/crops');
    }, [navigate]);

    
    // Efectos
    useEffect(() => {
        const loadSensors = async () => {
            try {
                const response = await getSensors(1, 1000);
                setSensors(response.content);
            } catch (error) {
                console.error('Error al cargar los sensores: ', error);
                alert("Error al cargar los sensores.");
            }
        };

        const fetchCrop = async () => {
            if (cropId !== 'newCrop') {
                try {
                    const response = await getCrop(cropId);
                    // reset(response);
                    reset({
                        ...response,
                        soilAnalysis: response.soilAnalysis !== undefined ? String(response.soilAnalysis) : '',
                        previousPlantings: response.previousPlantings !== undefined ? String(response.previousPlantings) : '',
                    });
                } catch (error) {
                    console.error(error);
                }
            }
        };

        loadSensors();
        fetchCrop();
    }, [cropId,reset]);

    // Manejador de envío
    const onSubmit = handleSubmit (async (data) => {
        
        const body = {
            crop: {
                ...(cropId !== 'newCrop' && { id: cropId }),
                ...Object.fromEntries(
                    Object.entries(data).filter(([key]) => key !== 'sensors')
                        .map(([key, value]) => [
                            key,
                            ['name', 'company', 'contact'].includes(key) ? 
                                toCapitalizeCase(value) : 
                                key === 'email' ? value.trim().toLowerCase() : 
                                value
                        ])
                )
            },
            sensors: data.sensors
        };

        try {
            if (cropId !== 'newCrop') {
                const response =  await editCrop(cropId, body);
                alert(response.message);
                
            } else {
                const response =  await addCrop(body);
                alert(response.message);
            }
            navigate('/crops');
            
        } catch (error) {
            console.error('Error al enviar el formulario: ', error);
            alert("Error al enviar el formulario. Por favor, intenta de nuevo.");
        }
    });

    return (
        <div className='flex flex-col p-3'>
            <div className="flex max-sm:flex-col items-center justify-between mb-4">
                <h1 className="text-3xl font-semibold text-blue-600">Cultivo</h1>
            </div>

            <div className="w-full max-w-3xl mx-auto ">
                <form onSubmit={onSubmit} className="flex flex-col items-center space-y-4 pb-2">
                    <h2 className="text-2xl font-semibold text-blue-600">Información de la compañía</h2>

                    <div className="flex flex-col w-full md:flex-row md:space-x-4 space-y-4 md:space-y-0">
                        <div className='w-full'>
                            <label htmlFor="name" className="block font-semibold text-black mb-1"> Nombre <span className="text-red-500">*</span></label>
                            <input id="name" type="text" autoComplete="name"
                                name="name"
                                {...register("name",{
                                    required: {
                                        value: true,
                                        message: 'Nombre es requerido'
                                    },
                                    minLength:{
                                        value: 2,
                                        message: 'Nombre debe tener al menos 2 caracteres'
                                    },
                                    maxLength:{
                                        value: 30,
                                        message: 'Nombre debe tener máximo 30 caracteres'
                                    }
                                })}
                                placeholder="Nombre"
                                className="block w-full p-2 bg-white border border-gray-200 text-black text-sm focus:outline-none focus:ring-2 focus:ring-blue-600 rounded shadow-md"
                            />
                            {
                                errors.name && <span className="error">{errors.name.message}</span>
                            }
                        </div>

                        <div className='w-full'>
                            <label htmlFor="company" className="block font-semibold text-black mb-1"> Empresa <span className="text-red-500">*</span></label>
                            <input id="company" type="text" autoComplete="off"
                                name="company"
                                placeholder="Empresa"
                                className="block w-full p-2 bg-white border border-gray-200 text-black text-sm focus:outline-none focus:ring-2 focus:ring-blue-600 rounded shadow-md"
                                {...register("company",{
                                    required: {
                                        value: true,
                                        message: 'Empresa es requerida'
                                    },
                                    minLength:{
                                        value: 2,
                                        message: 'Empresa debe tener al menos 2 caracteres'
                                    },
                                    maxLength:{
                                        value: 30,
                                        message: 'Empresa debe tener máximo 30 caracteres'
                                    }    
                                })}
                            />
                            {
                                errors.company && <span className="error">{errors.company.message}</span>
                            }
                        </div>
                    </div>

                    <div className="flex flex-col w-full md:flex-row md:space-x-4 space-y-4 md:space-y-0">
                        <div className='w-full'>
                            <label htmlFor="contact" className="block font-semibold text-black mb-1"> Contacto <span className="text-red-500">*</span></label>
                            <input id="contact" type="text" autoComplete="off"
                                name="contact"
                                placeholder="Contacto"
                                className="block w-full p-2 bg-white border border-gray-200 text-black text-sm focus:outline-none focus:ring-2 focus:ring-blue-600 rounded shadow-md"
                                {...register("contact",{
                                    required: {
                                        value: true,
                                        message: 'Contacto es requerido'
                                    }    
                                })}
                            />
                            {
                                errors.contact && <span className="error">{errors.contact.message}</span>
                            }
                        </div>

                        <div className='w-full'>
                            <label htmlFor="phone" className="block font-semibold text-black mb-1"> Teléfono <span className="text-red-500">*</span></label>
                            <input id="phone" type="text" autoComplete="off"
                                name="phone"
                                placeholder="Teléfono"
                                title="phone"
                                className="block w-full p-2 bg-white border border-gray-200 text-black text-sm focus:outline-none focus:ring-2 focus:ring-blue-600 rounded shadow-md"
                                {...register("phone",{
                                    required: {
                                        value: true,
                                        message: 'Teléfono es requerido'
                                    },
                                    pattern: {
                                        value: PHONE_PATTERN,
                                        message: 'Debe contener solo números' // Acepta solo números    
                                    },                                        
                                })}
                            />
                            {
                                errors.phone && <span className="error">{errors.phone.message}</span>
                            }
                        </div>
                    </div>

                    <div className="flex flex-col w-full md:flex-row md:space-x-4 space-y-4 md:space-y-0">
                        <div className='w-full'>
                            <label htmlFor="email" className="block font-semibold text-black mb-1"> Email <span className="text-red-500">*</span></label>
                            <input id="email" type="email" autoComplete="off"
                                name="email"
                                placeholder="Email"
                                className="block w-full p-2 bg-white border border-gray-200 text-black text-sm focus:outline-none focus:ring-2 focus:ring-blue-600 rounded shadow-md"
                                {...register("email",{
                                    required: {
                                        value: true,
                                        message: 'Email es requerido'
                                    }    
                                })}
                            />
                            {
                                errors.email && <span className="error">{errors.email.message}</span>
                            }
                        </div>
                    </div>

                    <div className="flex flex-col w-full md:flex-row md:space-x-4 space-y-4 md:space-y-0">
                        <div className='w-full'>
                            <label htmlFor="description" className="block font-semibold text-black mb-1"> Información adicional <span className="text-red-500">*</span></label>
                            <textarea id="description" autoComplete="off"
                                name="description"
                                placeholder="Información adicional"
                                rows="4" 
                                className="block w-full p-2 bg-white border border-gray-200 text-black text-sm focus:outline-none focus:ring-2 focus:ring-blue-600 rounded shadow-md resize-none"
                                {...register("description",{
                                    required: {
                                        value: true,
                                        message: 'Información adicional es requerida'
                                    }    
                                })}
                            />
                            {
                                errors.description && <span className="error">{errors.description.message}</span>
                            }
                            
                        </div>
                    </div>

                    <div className="w-full">
                        <div onClick={() => toggleAccordion('accordion_1')} 
                            className="cursor-pointer flex items-center text-2xl text-center font-semibold text-blue-600 hover:text-green-700 mb-4"
                        >
                            <h2 className="text-xl">Información del cultivo</h2>
                            <span className="material-icons ml-auto">
                                {accordionState.accordion_1 ? 'keyboard_arrow_up' : 'keyboard_arrow_down'}
                            </span>
                        </div>

                        <div className={`transition-all duration-500 space-y-2 overflow-hidden ${accordionState.accordion_1 ? 'max-h-full opacity-100 overflow-visible' : 'max-h-0 opacity-0'}`}>
                            <div className="flex flex-col w-full md:flex-row md:space-x-4 space-y-4 md:space-y-0">
                                {/* <div className='w-full'>
                                    <label htmlFor="crop" className="block font-semibold text-black mb-1"> Tipo de cultivo <span className="text-red-500">*</span></label>
                                    <input id="crop" type="text" autoComplete="off"
                                        name="crop"
                                        placeholder="Tipo de cultivo"
                                        className="block w-full p-2 bg-white border border-gray-200 text-black text-sm focus:outline-none focus:ring-2 focus:ring-blue-600 rounded shadow-md"
                                        {...register("crop",{
                                            required: {
                                                value: true,
                                                message: 'Tipo de cultivo es requerido'
                                            }    
                                        })}
                                    />
                                    {
                                        errors.crop && <span className="error">{errors.crop.message}</span>
                                    }
                                </div> */}
                                <div className='w-full'>
                                    <label htmlFor="crop" className="block font-semibold text-black mb-1"> Tipo de cultivo <span className="text-red-500">*</span></label>
                                    <select id="crop" 
                                        name="crop" 
                                        {...register("crop",{
                                            required: {
                                                value: true,
                                                message: 'Tipo de fertilizante es requerida'
                                            }    
                                        })}
                                        className="block w-full px-2 py-1 bg-white border border-gray-200 text-black text-sm focus:outline-none focus:ring-2 focus:ring-blue-600 rounded shadow-md"
                                    >
                                        <option value="" disabled> Tipo de cultivo </option>
                                        {CROP_OPTIONS.map((option, index) => (
                                            <option key={index} value={option.value}>{option.label}</option>
                                        ))}
                                    </select>
                                    {
                                        errors.crop && <span className="error">{errors.crop.message}</span>
                                    }
                                </div>
                            </div>

                            <div className="flex flex-col w-full md:flex-row md:space-x-4 space-y-4 md:space-y-0">
                                <div className='w-full'>
                                    <label htmlFor="location" className="block font-semibold text-black mb-1"> Ubicación <span className="text-red-500">*</span></label>
                                    <input id="location" type="text" autoComplete="off"
                                        name="location"
                                        placeholder="Ubicación"
                                        className="block w-full p-2 bg-white border border-gray-200 text-black text-sm focus:outline-none focus:ring-2 focus:ring-blue-600 rounded shadow-md"
                                        {...register("location",{
                                            required: {
                                                value: true,
                                                message: 'Ubicación es requerida'
                                            }    
                                        })}
                                    />
                                    {
                                        errors.location && <span className="error">{errors.location.message}</span>
                                    }
                                </div>

                                <div className='w-full'>
                                    <label htmlFor="variety" className="block font-semibold text-black mb-1"> Variedad <span className="text-red-500">*</span></label>
                                    <input id="variety" type="text" autoComplete="off"
                                        name="variety"
                                        placeholder="Variedad"
                                        className="block w-full p-2 bg-white border border-gray-200 text-black text-sm focus:outline-none focus:ring-2 focus:ring-blue-600 rounded shadow-md"
                                        {...register("variety",{
                                            required: {
                                                value: true,
                                                message: 'Variedad es requerida'
                                            }    
                                        })}
                                    />
                                    {
                                        errors.variety && <span className="error">{errors.variety.message}</span>
                                    }
                                </div>
                            </div>

                            <div className="flex flex-col w-full md:flex-row md:space-x-4 space-y-4 md:space-y-0">
                                <div className='w-full'>
                                    <label htmlFor="cropAge" className="block font-semibold text-black mb-1"> Edad <span className="text-red-500">*</span></label>
                                    <input id="cropAge" type="text" autoComplete="off"
                                        name="cropAge"
                                        placeholder="Edad"
                                        className="block w-full p-2 bg-white border border-gray-200 text-black text-sm focus:outline-none focus:ring-2 focus:ring-blue-600 rounded shadow-md"
                                        {...register("cropAge",{
                                            required: {
                                                value: true,
                                                message: 'Edad es requerida'
                                            }    
                                        })}
                                    />
                                    {
                                        errors.cropAge && <span className="error">{errors.cropAge.message}</span>
                                    }
                                </div>

                                <div className='w-full'>
                                    <label htmlFor="timeToHarvest" className="block font-semibold text-black mb-1"> Periodo de siembra <span className="text-red-500">*</span></label>
                                    <input id="timeToHarvest" type="text" autoComplete="off"
                                        name="timeToHarvest"
                                        placeholder="Periodo de siembra"
                                        className="block w-full p-2 bg-white border border-gray-200 text-black text-sm focus:outline-none focus:ring-2 focus:ring-blue-600 rounded shadow-md"
                                        {...register("timeToHarvest",{
                                            required: {
                                                value: true,
                                                message: 'Periodo de siembra'
                                            }    
                                        })}
                                    />
                                    {
                                        errors.timeToHarvest && <span className="error">{errors.timeToHarvest.message}</span>
                                    }
                                </div>
                            </div>

                            <div className="flex flex-col w-full md:flex-row md:space-x-4 space-y-4 md:space-y-0">
                                <div className='w-full'>
                                    <label htmlFor="soilType" className="block font-semibold text-black mb-1"> Tipo de suelo <span className="text-red-500">*</span></label>
                                    <input id="soilType" type="text" autoComplete="off"
                                        name="soilType"
                                        placeholder="Tipo de suelo"
                                        className="block w-full p-2 bg-white border border-gray-200 text-black text-sm focus:outline-none focus:ring-2 focus:ring-blue-600 rounded shadow-md"
                                        {...register("soilType",{
                                            required: {
                                                value: true,
                                                message: 'Tipo de suelo es requerida'
                                            }    
                                        })}
                                    />
                                    {
                                        errors.soilType && <span className="error">{errors.soilType.message}</span>
                                    }
                                </div>

                                <div className='w-full'>
                                    <label htmlFor="area" className="block font-semibold text-black mb-1"> Area sembrada <span className="text-red-500">*</span></label>
                                    <input id="area" type="text" autoComplete="off"
                                        name="area"
                                        placeholder="Area sembrada"
                                        className="block w-full p-2 bg-white border border-gray-200 text-black text-sm focus:outline-none focus:ring-2 focus:ring-blue-600 rounded shadow-md"
                                        {...register("area",{
                                            required: {
                                                value: true,
                                                message: 'Area sembrada'
                                            }    
                                        })}
                                    />
                                    {
                                        errors.area && <span className="error">{errors.area.message}</span>
                                    }
                                </div>
                            </div>

                            <div className="flex flex-col w-full md:flex-row md:space-x-4 space-y-4 md:space-y-0">
                                <div className='w-full'>
                                    <label htmlFor="infrastructure" className="block font-semibold text-black mb-1"> Infraestructura <span className="text-red-500">*</span></label>
                                    <input id="infrastructure" type="text" autoComplete="off"
                                        name="infrastructure"
                                        placeholder="Infraestructura"
                                        className="block w-full p-2 bg-white border border-gray-200 text-black text-sm focus:outline-none focus:ring-2 focus:ring-blue-600 rounded shadow-md"
                                        {...register("infrastructure",{
                                            required: {
                                                value: true,
                                                message: 'Infraestructura es requerida'
                                            }    
                                        })}
                                    />
                                    {
                                        errors.infrastructure && <span className="error">{errors.infrastructure.message}</span>
                                    }
                                </div>

                                <div className='w-full'>
                                    <label htmlFor="productivityPerPlant" className="block font-semibold text-black mb-1"> Productividad por planta o área <span className="text-red-500">*</span></label>
                                    <input id="productivityPerPlant" type="text" autoComplete="off"
                                        name="productivityPerPlant"
                                        placeholder="Productividad por planta o área"
                                        className="block w-full p-2 bg-white border border-gray-200 text-black text-sm focus:outline-none focus:ring-2 focus:ring-blue-600 rounded shadow-md"
                                        {...register("productivityPerPlant",{
                                            required: {
                                                value: true,
                                                message: 'Productividad por planta o área es requerida'
                                            }    
                                        })}
                                    />
                                    {
                                        errors.productivityPerPlant && <span className="error">{errors.productivityPerPlant.message}</span>
                                    }
                                </div>
                            </div>

                            <div className="flex flex-col w-full md:flex-row md:space-x-4 space-y-4 md:space-y-0">
                                <div className='w-full'>
                                    <label htmlFor="peopleInArea" className="block font-semibold text-black mb-1"> Personas por área <span className="text-red-500">*</span></label>
                                    <input id="peopleInArea" type="number" autoComplete="off"
                                        name="peopleInArea"
                                        placeholder="Personas por área"
                                        className="block w-full p-2 bg-white border border-gray-200 text-black text-sm focus:outline-none focus:ring-2 focus:ring-blue-600 rounded shadow-md"
                                        {...register("peopleInArea",{
                                            required: {
                                                value: true,
                                                message: 'Personas por área es requerida'
                                            }    
                                        })}
                                    />
                                    {
                                        errors.peopleInArea && <span className="error">{errors.peopleInArea.message}</span>
                                    }
                                </div>

                                <div className='w-full'>
                                    <label htmlFor="measurementElementManagement" className="block font-semibold text-black mb-1"> Elementos de medición en cultivo <span className="text-red-500">*</span></label>
                                    <input id="measurementElementManagement" type="text" autoComplete="off"
                                        name="measurementElementManagement"
                                        placeholder="Elementos de medición en cultivo"
                                        className="block w-full p-2 bg-white border border-gray-200 text-black text-sm focus:outline-none focus:ring-2 focus:ring-blue-600 rounded shadow-md"
                                        {...register("measurementElementManagement",{
                                            required: {
                                                value: true,
                                                message: 'Elementos de medición en cultivo es requerida'
                                            }    
                                        })}
                                    />
                                    {
                                        errors.measurementElementManagement && <span className="error">{errors.measurementElementManagement.message}</span>
                                    }
                                </div>
                            </div>

                            <div className="flex flex-col w-full md:flex-row md:space-x-4 space-y-4 md:space-y-0">
                                <div className='w-full'>
                                    <label htmlFor="fertilizerType" className="block font-semibold text-black mb-1"> Tipo de fertilizante <span className="text-red-500">*</span></label>
                                    <select id="fertilizerType" 
                                        name="fertilizerType" 
                                        {...register("fertilizerType",{
                                            required: {
                                                value: true,
                                                message: 'Tipo de fertilizante es requerida'
                                            }    
                                        })}
                                        className="block w-full px-2 py-1 bg-white border border-gray-200 text-black text-sm focus:outline-none focus:ring-2 focus:ring-blue-600 rounded shadow-md"
                                    >
                                        <option value="" disabled> Tipo de fertilizante </option>
                                        {FERTILIZATION_OPTIONS.map((option, index) => (
                                            <option key={index} value={option.value}>{option.label}</option>
                                        ))}
                                    </select>
                                    {
                                        errors.fertilizerType && <span className="error">{errors.fertilizerType.message}</span>
                                    }
                                </div>

                                <div className='w-full'>
                                    <label htmlFor="fertilizerFrequency" className="block font-semibold text-black mb-1"> Frecuencia de fertilización <span className="text-red-500">*</span></label>
                                    <input id="fertilizerFrequency" type="text" autoComplete="off"
                                        name="fertilizerFrequency"
                                        placeholder="Frecuencia de fertilización"
                                        className="block w-full p-2 bg-white border border-gray-200 text-black text-sm focus:outline-none focus:ring-2 focus:ring-blue-600 rounded shadow-md"
                                        {...register("fertilizerFrequency",{
                                            required: {
                                                value: true,
                                                message: 'Frecuencia de fertilización es requerida'
                                            }    
                                        })}
                                    />
                                    {
                                        errors.fertilizerFrequency && <span className="error">{errors.fertilizerFrequency.message}</span>
                                    }
                                </div>
                            </div>

                            <div className="flex flex-col w-full md:flex-row md:space-x-4 space-y-4 md:space-y-0">
                                <div className='w-full'>
                                    <label htmlFor="soilAnalysis" className="block font-semibold text-black mb-1"> ¿Análisis de suelo? <span className="text-red-500">*</span></label>
                                    <select id="soilAnalysis" 
                                        name="soilAnalysis" 
                                        {...register("soilAnalysis",{
                                            required: {
                                                value: true,
                                                message: 'Análisis de suelo es requerida'
                                            }    
                                        })} 
                                        className="block w-full px-2 py-1 bg-white border border-gray-200 text-black text-sm focus:outline-none focus:ring-2 focus:ring-blue-600 rounded shadow-md"
                                    >
                                        <option value="" disabled> ¿Análisis de suelo? </option>
                                        {BINARY_OPTIONS.map((option, index) => (
                                            <option key={index} value={option.value}>{option.label}</option>
                                        ))}
                                    </select>
                                    {
                                        errors.soilAnalysis && <span className="error">{errors.soilAnalysis.message}</span>
                                    }
                                </div>

                                <div className='w-full'>
                                    <label htmlFor="previousPlantings" className="block font-semibold text-black mb-1"> ¿Siembras anteriores? <span className="text-red-500">*</span></label>
                                    <select id="previousPlantings" 
                                        name="previousPlantings" 
                                        {...register("previousPlantings",{
                                            required: {
                                                value: true,
                                                message: '¿Siembras anteriores? es requerida'
                                            }    
                                        })}
                                        className="block w-full px-2 py-1 bg-white border border-gray-200 text-black text-sm focus:outline-none focus:ring-2 focus:ring-blue-600 rounded shadow-md"
                                    >
                                        <option value="" disabled> ¿Siembras anteriores? </option>
                                        {BINARY_OPTIONS.map((option, index) => (
                                            <option key={index} value={option.value}>{option.label}</option>
                                        ))}
                                    </select>
                                    {
                                        errors.previousPlantings && <span className="error">{errors.previousPlantings.message}</span>
                                    }
                                </div>
                            </div>

                            <div className="flex flex-col w-full md:flex-row md:space-x-4 space-y-4 md:space-y-0">
                                <div className='w-full'>
                                    <label htmlFor="cropHistory" className="block font-semibold text-black mb-1"> Historial del cultivo <span className="text-red-500">*</span></label>
                                    <textarea id="cropHistory" autoComplete="off"
                                        name="cropHistory"
                                        placeholder="Historial del cultivo"
                                        rows="4" 
                                        className="block w-full p-2 bg-white border border-gray-200 text-black text-sm focus:outline-none focus:ring-2 focus:ring-blue-600 rounded shadow-md resize-none"
                                        {...register("cropHistory",{
                                            required: {
                                                value: true,
                                                message: 'Historial del cultivo es requerida'
                                            }    
                                        })}
                                    />
                                    {
                                        errors.cropHistory && <span className="error">{errors.cropHistory.message}</span>
                                    }
                                </div>
                            </div>

                            <div className="flex flex-col w-full md:flex-row md:space-x-4 space-y-4 md:space-y-0">
                                <div className='w-full'>
                                    <label htmlFor="observations" className="block font-semibold text-black mb-1"> Observaciones <span className="text-red-500">*</span></label>
                                    <textarea id="observations" autoComplete="off"
                                        name="observations"
                                        placeholder="Observaciones"
                                        rows="4" 
                                        className="block w-full p-2 bg-white border border-gray-200 text-black text-sm focus:outline-none focus:ring-2 focus:ring-blue-600 rounded shadow-md resize-none"
                                        {...register("observations",{
                                            required: {
                                                value: true,
                                                message: 'Observaciones es requerida'
                                            }    
                                        })}
                                    />
                                    {
                                        errors.observations && <span className="error">{errors.observations.message}</span>
                                    }
                                </div>
                            </div>

                        </div>
                    </div>

                    <div className="w-full">
                        <div onClick={() => toggleAccordion('accordion_2')} 
                            className="cursor-pointer flex items-center text-2xl text-center font-semibold text-blue-600 hover:text-green-700 mb-4"
                        >
                            <h2 className="text-xl">Información del riego</h2>
                            <span className="material-icons ml-auto">
                                {accordionState.accordion_2 ? 'keyboard_arrow_up' : 'keyboard_arrow_down'}
                            </span>
                        </div>

                        <div className={`transition-all duration-500 space-y-2 overflow-hidden ${accordionState.accordion_2 ? 'max-h-full opacity-100 overflow-visible' : 'max-h-0 opacity-0'}`}>
                            <div className="flex flex-col w-full md:flex-row md:space-x-4 space-y-4 md:space-y-0">
                                <div className='w-full'>
                                    <label htmlFor="irrigation" className="block font-semibold text-black mb-1"> Sistema de riego <span className="text-red-500">*</span></label>
                                    <input id="irrigation" type="text" autoComplete="off"
                                        name="irrigation"
                                        placeholder="Sistema de riego"
                                        className="block w-full p-2 bg-white border border-gray-200 text-black text-sm focus:outline-none focus:ring-2 focus:ring-blue-600 rounded shadow-md"
                                        {...register("irrigation",{
                                            required: {
                                                value: true,
                                                message: 'Sistema de riego es requerido'
                                            }    
                                        })}
                                    />
                                    {
                                        errors.irrigation && <span className="error">{errors.irrigation.message}</span>
                                    }
                                </div>

                                <div className='w-full'>
                                    <label htmlFor="frequency" className="block font-semibold text-black mb-1"> Frecuencia de riego <span className="text-red-500">*</span></label>
                                    <input id="frequency" type="text" autoComplete="off"
                                        name="frequency"
                                        placeholder="Frecuencia de riego"
                                        className="block w-full p-2 bg-white border border-gray-200 text-black text-sm focus:outline-none focus:ring-2 focus:ring-blue-600 rounded shadow-md"
                                        {...register("frequency",{
                                            required: {
                                                value: true,
                                                message: 'Frecuencia de riego es requerida'
                                            }    
                                        })}
                                    />
                                    {
                                        errors.frequency && <span className="error">{errors.frequency.message}</span>
                                    }
                                </div>
                            </div>

                            <div className="flex flex-col w-full md:flex-row md:space-x-4 space-y-4 md:space-y-0">
                                <div className='w-full'>
                                    <label htmlFor="engine" className="block font-semibold text-black mb-1"> Tipo de riego <span className="text-red-500">*</span></label>
                                    <select id="engine" 
                                        name="engine" 
                                        {...register("engine",{
                                            required: {
                                                value: true,
                                                message: 'Tipo de riego es requerida'
                                            }    
                                        })} 
                                        className="block w-full px-2 py-1 bg-white border border-gray-200 text-black text-sm focus:outline-none focus:ring-2 focus:ring-blue-600 rounded shadow-md"
                                    >
                                        <option value="" disabled> Tipo de riego </option>
                                        {IRRIGATION_TYPE.map((option, index) => (
                                            <option key={index} value={option.value}>{option.label}</option>
                                        ))}
                                    </select>
                                    {
                                        errors.engine && <span className="error">{errors.engine.message}</span>
                                    }
                                </div>

                                <div className='w-full'>
                                    <label htmlFor="advisoryService" className="block font-semibold text-black mb-1"> ¿Asesoría técnica? <span className="text-red-500">*</span></label>
                                    <select id="advisoryService" 
                                        name="advisoryService" 
                                        {...register("advisoryService",{
                                            required: {
                                                value: true,
                                                message: '¿Asesoría técnica es requerida'
                                            }    
                                        })} 
                                        className="block w-full px-2 py-1 bg-white border border-gray-200 text-black text-sm focus:outline-none focus:ring-2 focus:ring-blue-600 rounded shadow-md"
                                    >
                                        <option value="" disabled> ¿Asesoría técnica? </option>
                                        {BINARY_OPTIONS.map((option, index) => (
                                            <option key={index} value={option.value}>{option.label}</option>
                                        ))}
                                    </select>
                                    {
                                        errors.advisoryService && <span className="error">{errors.advisoryService.message}</span>
                                    }
                                </div>
                            </div>

                            <div className="flex flex-col w-full md:flex-row md:space-x-4 space-y-4 md:space-y-0">
                                <div className='w-full'>
                                    <label htmlFor="volume" className="block font-semibold text-black mb-1"> Volumen de agua, cama o surco <span className="text-red-500">*</span></label>
                                    <input id="volume" type="text" autoComplete="off"
                                        name="volume"
                                        placeholder="Volumen de agua, cama o surco"
                                        className="block w-full p-2 bg-white border border-gray-200 text-black text-sm focus:outline-none focus:ring-2 focus:ring-blue-600 rounded shadow-md"
                                        {...register("volume",{
                                            required: {
                                                value: true,
                                                message: 'Volumen de agua, cama o surco es requerida'
                                            }    
                                        })}
                                    />
                                    {
                                        errors.volume && <span className="error">{errors.volume.message}</span>
                                    }
                                </div>

                                <div className='w-full'>
                                    <label htmlFor="waterCollection" className="block font-semibold text-black mb-1"> Captación de agua <span className="text-red-500">*</span></label>
                                    <input id="waterCollection" type="text" autoComplete="off"
                                        name="waterCollection"
                                        placeholder="Captación de agua"
                                        className="block w-full p-2 bg-white border border-gray-200 text-black text-sm focus:outline-none focus:ring-2 focus:ring-blue-600 rounded shadow-md"
                                        {...register("waterCollection",{
                                            required: {
                                                value: true,
                                                message: 'Captación de agua es requerida'
                                            }    
                                        })}
                                    />
                                    {
                                        errors.waterCollection && <span className="error">{errors.waterCollection.message}</span>
                                    }
                                </div>
                            </div>

                            <div className="flex flex-col w-full md:flex-row md:space-x-4 space-y-4 md:space-y-0">
                                <div className='w-full'>
                                    <label htmlFor="emitter" className="block font-semibold text-black mb-1"> Tipo de emisor <span className="text-red-500">*</span></label>
                                    <input id="emitter" type="text" autoComplete="off"
                                        name="emitter"
                                        placeholder="Tipo de emisor"
                                        className="block w-full p-2 bg-white border border-gray-200 text-black text-sm focus:outline-none focus:ring-2 focus:ring-blue-600 rounded shadow-md"
                                        {...register("emitter",{
                                            required: {
                                                value: true,
                                                message: 'Tipo de emisor es requerida'
                                            }    
                                        })}
                                    />
                                    {
                                        errors.emitter && <span className="error">{errors.emitter.message}</span>
                                    }
                                </div>

                                <div className='w-full'>
                                    <label htmlFor="emitterFlow" className="block font-semibold text-black mb-1"> Caudal del emisor <span className="text-red-500">*</span></label>
                                    <input id="emitterFlow" type="text" autoComplete="off"
                                        name="emitterFlow"
                                        placeholder="Caudal del emisor"
                                        className="block w-full p-2 bg-white border border-gray-200 text-black text-sm focus:outline-none focus:ring-2 focus:ring-blue-600 rounded shadow-md"
                                        {...register("emitterFlow",{
                                            required: {
                                                value: true,
                                                message: 'Caudal del emisor es requerida'
                                            }    
                                        })}
                                    />
                                    {
                                        errors.emitterFlow && <span className="error">{errors.emitterFlow.message}</span>
                                    }
                                </div>
                            </div>
                        </div>
                    </div>

                    <div className="w-full">
                        <h2 className="text-xl font-semibold text-blue-600 mb-2">Selección de Sensores</h2>
                        <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-4 overflow-y-auto max-h-80 p-2">
                        {sensors.map((sensor) => (
                            <div
                                key={sensor.id}
                                className={`
                                    flex items-center p-3 rounded-lg cursor-pointer transition-all duration-200 shadow-md
                                    ${getValues("sensors").includes(sensor.id) ? 'bg-blue-100 border-2 border-blue-600' : 'bg-gray-100 hover:bg-gray-200 border border-gray-300'}
                                `}
                                onClick={() => handleSensorSelection(sensor.id)} // Ejecutar handleSensorSelection al hacer clic en el div
                            >
                                <Controller
                                    name="sensors"
                                    control={control}
                                    render={({ field }) => (
                                        <input
                                            type="checkbox"
                                            id={`sensor-checkbox-${sensor.id}`}
                                            value={sensor.id}
                                            checked={getValues("sensors").includes(sensor.id) || false} // Sincronizar con el estado
                                            onChange={() => {}} // Evitar manejo predeterminado de onChange
                                            className="mr-3 form-checkbox text-blue-600 focus:ring-blue-600 h-5 w-5 cursor-pointer"
                                        />
                                    )}
                                />
                                <span className="text-sm font-medium">{sensor.id}</span>
                            </div>
                        ))}

                        </div>
                    </div>

                    <div className="flex flex-col md:flex-row items-center justify-center md:space-x-4">
                        <div className="w-full">
                            <button type="submit" className="flex flex-1 rounded w-full justify-center text-white bg-blue-600 hover:bg-blue-800 font-medium px-5 py-2.5 me-2 mb-2 transition duration-200">
                                Guardar
                            </button>
                        </div>

                        <div className="w-full">
                            <button type="button" onClick={handleCancel} className="flex flex-1 rounded w-full justify-center text-white bg-red-600 hover:bg-red-800 font-medium px-5 py-2.5 me-2 mb-2 transition duration-200">
                                Cancelar
                            </button>
                        </div>
                    </div>
                </form>
            </div>
        </div>
    );
}

export default CropView;